import React, {useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCanvasSize } from '../../../redux/canvasSize/canvasSizeSlice';
import Tab from './Tab';
import './tabs.scss';
import './tab.scss';

export default function Tabs({ handlerAddTab, handlerCloseTab, activeTab, reticles, activeTabId, handlerActiveTab }) {
  const [currentURL, setCurrentURL] = useState(window.location.pathname);

  const canvasSizesArr = useSelector((state) => state.canvasSize.canvasSizes);

  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentURL(window.location.pathname);
  }, [currentURL]);

  useEffect(() => {
    const width = parseInt((activeTab.svg.match(/width="(\d+)"/) || [])[1]);
    const height = parseInt((activeTab.svg.match(/height="(\d+)"/) || [])[1]);
    if (width && height && !canvasSizesArr[activeTab.id]) {
      dispatch(setCanvasSize({tabID: activeTab.id, size: [width, height]}));
    }
  }, [activeTab]);

  const reticlesNumb = reticles.length < 10;

  return (
    <section className='tabs_section'>
      <ul className='tabs_list-style'>
        {reticles.map((el) => (
            <li className={`tabs__item`} key={el.id}>
              <div className={`tab_block ${(activeTabId === el.id) ? 'active_tab' : ''}`} onClick={() => handlerActiveTab(el.id, el.name)} >
                <Tab key={el.id} id={el.id} name={el.name} handlerCloseTab={handlerCloseTab} docName={el.name} activeTab={activeTab}/>
              </div>
          </li>
        ))}
        { currentURL !== '/preview' &&
          <button id='newDocBtn' className={reticlesNumb ? 'new-doc_btn' : 'new-doc_btn-invisible'} onClick={handlerAddTab}></button>
        }
      </ul>
    </section>
  );
}
